'use client'

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { colors } from "../../tailwind.config";
import HeaderUserSection from "./HeaderUserSection";
import { AppointmentsIcon, CommunityIcon, LabayhIcon, MoreIcon, ProgramsIcon } from "./Icons";
import UnSeenMessages from "./UnSeenMessages";
import { ClockIcon } from "@/app/appointments/Icons";
import useAppSearchParams from "@/hooks/useAppSearchParams";
import { ChatIcon } from "@/app/appointments/[id]/Icons";


export default function Header() {

  const pathName = usePathname();
  const isBookingScreen = pathName === "/book-instant";
  const isAppointmentsScreen = pathName === "/appointments";
  const isChatScreen = pathName.includes("/appointments/");
  const { value: modeValue } = useAppSearchParams("mode");
  const mode = modeValue === "call" || modeValue === "call-with-chat" ? modeValue : "chat";
  const isChatMode = mode === "chat";
  const isLoginScreen = pathName === "/login";

  if (isLoginScreen) return null

  const screens = <>
    {[
      { label: "الرئيسية", icon: LabayhIcon, path: "/" },
      { label: "المواعيد", icon: AppointmentsIcon, path: "/appointments" },
      { label: "الخطط العلاجية", icon: ProgramsIcon, path: "/programs" },
      { label: "المجتمع", icon: CommunityIcon, path: "/community" },
      { label: "المزيد", icon: MoreIcon, path: "/more" }
    ].map((item, index) => {
      const active = pathName === item.path;
      const Icon = item.icon
      return <Link href={item.path} key={index} className="flex flex-col items-center">
        <div className="relative">
          <span className="text-[21px]">
          <Icon color={active ? colors.blue.base : colors.gray.base} />
          </span>
          {index === 1 ? <UnSeenMessages /> : null}
        </div>
        <div className={["text-base mt-1.5 font-medium", active ? "text-blue-base" : "text-black"].join(" ")}>
          {item.label}
        </div>
      </Link>
    })}
  </>

  return (
    <div className="w-full md:px-1 md:py-6 fixed container bg-white-base md:bg-[#F8F8FB] z-50">
      <div className="flex flex-1 flex-row items-center justify-between p-4 md:p-0">
        <div className="hidden md:block">
          <Image
            src="/images/labayh-logo.png"
            alt="Vercel Logo"
            width={132}
            height={53}
            className="object-contain "
            priority
          />
        </div>
        <div className="md:hidden">
          <LabayhIcon color={colors.blue.base} size={40} />
        </div>
        {isBookingScreen || isAppointmentsScreen || isChatScreen ? <div className="md:hidden flex items-center">
          {isChatScreen ? isChatMode ? <ChatIcon /> : null : <ClockIcon />}
          <div className="text-black-base font-medium mr-2">
            {isChatScreen ? isChatMode ? "المحادثة" : "المكالمة" : isAppointmentsScreen ? "مواعيدي" : "حجز جلسة فورية"}
          </div>
        </div> : null}
        <div className="hidden md:flex gap-[44px]">
          {screens}
        </div>
        <HeaderUserSection />
      </div>
      <div className="flex md:hidden justify-center gap-[16px] px-6 py-4 border-y border-y-devider">
        {screens}
      </div>
    </div>
  );

}
